import React from 'react';
import PropTypes from 'prop-types';

import { XIcon } from "@heroicons/react/solid";

export default class CloseButton extends React.Component
{
    static propTypes = {
        onClick: PropTypes.func.isRequired,
    };

    render()
    {
        return <button className="absolute right-0 top-0 p-1 m-2 inline-flex items-center justify-center text-gray-400 rounded-full bg-transparent hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:text-gray-500 focus:bg-gray-100 transition ease-in-out duration-150" onClick={this.props.onClick}>
            <XIcon className='w-4' />
        </button>;
    }
}

